import { RingLoader } from "react-spinners";

import { cn } from "@utils/tailwindUtils";

export default function Loading({ className }: { className?: string }) {
  return (
    <div className={cn("h-full content-center justify-center", className)}>
      <RingLoader className="m-auto" color="#0f62fe" />
    </div>
  );
}

export function LoadingModal({ isOpen = true }: { isOpen?: boolean }) {
  if (!isOpen) return <></>;
  return (
    <dialog
      open
      className="animate-in fade-in fill-mode-forwards absolute top-0 left-0 z-30 flex h-full w-full items-center justify-center bg-gray-700/50 duration-1000"
    >
      <RingLoader color="#0f62fe" />
    </dialog>
  );
}
